import React, { useEffect, useState } from "react";
import PostImage from "./PostImage";
import axios from "../../../../axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function SinglePostImage({ isPostCreated, communityId, commentLength, postId }) {
  const currentUser = useSelector((state) => state.user.currentUser);
  const StudentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [postList, setPostList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [filter, setFilter] = useState({
    limit: 20,
    page: 1,
    sortBy: -1,
  });

  const { limit, page, sortBy } = filter;

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("single-post-image-scroll").clientHeight +
        document.getElementById("single-post-image-scroll").scrollTop +
        1 >=
        document.getElementById("single-post-image-scroll").scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("single-post-image-scroll");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page]);

  const getPosts = async () => {
    try {
      if (isLastPage) {
        setIsLoading(false);
        return false;
      }
      setIsLoading(true)
      const post = await axios.get(
        // `/community/post/getByCommunityId/${communityId}?_page=${page}&_limit=${limit}&sortBy=${sortBy}`
        `/community/post/getByCommunityId/${communityId}?userId=${currentUser?.id}&_page=${page}&_limit=${limit}&sortBy=${sortBy}`
      );
      let data = [];
      post.data.data.map((posts) => {
        if (posts.isDeleted) {
          if (StudentData?.id === posts?.user_id?.id) {
            data.push(posts)
          }
        } else {
          data?.push(posts)
        }
      })
      post && setPostList((prevData) => [...prevData, ...data]);
      const totalFetchedPosts = postList.length + post.data.data.length;

      const loadedQuery = Math.min(totalFetchedPosts, post.data.total_post_count);
      if (post.data.data.length == 0 || loadedQuery === post.data.total_post_count) {
        setIsLastPage(true);
      }
      if (post.data.data.length > 0) {
        toast.info(`Loading Post (${loadedQuery + "/" + post.data.total_post_count})`, {
          position: "bottom-center",
        });
      } else {
        toast.info(`Loaded Post (${loadedQuery + "/" + post.data.total_post_count})`, {
          position: "bottom-center",
        });
      }
      setIsLoading(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false)
    }
  };
  useEffect(() => {
    if (isPostCreated) {
      setPostList([]);
    }
    getPosts();
    // setIsLoading(false)
  }, [page, limit, isPostCreated]);

  // useEffect(() => {
  //   const getPostComme = async () => {
  //     try {
  //       const res = await axios.get(
  //         `/community/post/${postId}/comment/get?sortBy=-1`
  //       );
  //       console.log("res---->", res)
  //       let data = [];
  //       res.data.data.map((posts) => {
  //         if (posts.isDeleted) {
  //           if (StudentData?.id === posts?.user_id?.id) {
  //             data.push(posts)
  //           }
  //         } else {
  //           data?.push(posts)
  //         }
  //       })

  //       // res && setComments((prev) => [...prev, ...data]);
  //       getPostComme()
  //     } catch (error) {
  //       console.log("error", error)
  //     }
  //   };
  //   getPostComme()
  // }, [])


  return (
    <div className="w-full">
      {/* {postList && postList.length > 0 ?
        postList.map((post) => <PostImage post={post} key={post.id} commentLength={commentLength} communityId={communityId} />)
        : !isLoading &&
        <div className="view_no_post_msg mt-3">
          No posts yet. Be the first one to add a post to community.
        </div>
      } */}
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center">
          <img
            className="request_post_loader"
            src="/gif/LoaderDot.gif"
            alt="Loading..."
          />
        </div>
      ) : (
        postList.length > 0 ? (
          postList.map((post) => (
            <PostImage
              post={post}
              key={post.id}
              commentLength={commentLength}
              communityId={communityId} />
          ))
        ) : (
          <div className="view_no_post_msg mt-3">
            No posts yet. Be the first one to add a post to community.
          </div>
        )
      )}
    </div>
  );
}

export default SinglePostImage;
